module.exports = __webpack_public_path__ + "static/Obi-Ikegulu-2e80174caf92b9ac4df0331827f4d48d.jpg";